<template>
  <div id="bindWeChatConfirm">
    <div class="confirm-pane" v-if="status == 1">
      <div class="msg-box">
        <div class="header">
          <i class="weui-icon-info weui-icon_msg"></i>
        </div>
        <p>您确认要绑定供应链账号</p>
        <p>{{ session.UserName || session.Mobile }}?</p>
      </div>
      <div class="button-box">
        <div class="button-wrapper">
          <van-button size="large" type="primary" :disabled="lockedConfirm" @click="onConfirm">确认
          </van-button>
        </div>
      </div>
    </div>
    <div class="success-pane" v-if="status == 2">
      <div class="msg-box">
        <div class="header">
          <i class="weui-icon-success weui-icon_msg"></i>
        </div>
        <p>已绑定成功</p>
      </div>
    </div>
    <div class="success-pane" v-if="status == 3">
      <div class="msg-box">
        <div class="header">
          <i class="weui-icon-warn weui-icon_msg"></i>
        </div>
        <p>会话已失效</p>
      </div>
    </div>
    <WeChatTips />
  </div>
</template>

<script>
import UserWeChatSetupApi from '~/api/user-wechat-setup-api'
import WeChatTips from '~/views/WeChatLoginConfirm/wechat-tips.vue'

export default {
  name: 'BindWeChatConfirm',
  components: {
    WeChatTips,
  },

  data() {
    return {
      code: "",
      session: {
        Mobile: "",
        UserName: ""
      },
      status: 0,
      lockedConfirm: false,
    }
  },

  methods: {
    async loadSession() {
      const { code } = this.$route.query

      // status设定
      // 1. 绑定账号
      // 2. 绑定成功
      // 3. 会话失效

      const sendData = {
        Id: code,
        Scan: true,
      }
      const session = await UserWeChatSetupApi.get(sendData)
      if (session == null) {
        this.status = 3
        return
      }

      this.code = code
      this.session = session

      const { IsExpiresd, Completed } = session
      if (IsExpiresd) {
        this.status = 3
        return
      }

      if (Completed != null) {
        this.status = 2
        return
      }

      this.status = 1
    },

    async onConfirm() {
      if (this.lockedConfirm) {
        return
      }

      this.lockedConfirm = true

      try {
        const { Id } = this.session
        const sendData = { Id }
        await UserWeChatSetupApi.bind(sendData)
        this.status = 2
      } finally {
        this.lockedConfirm = false
      }
    }
  },

  async created() {
    await this.loadSession()
  }
}
</script>

<style lang="less" scoped>
#bindWeChatConfirm {
  position: relative;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;

  >:first-child {
    flex: 1;
  }

  [class^="weui-icon-"],
  [class*=" weui-icon-"] {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    mask-position: 50% 50%;
    mask-repeat: no-repeat;
    mask-size: 100%;
    background-color: currentColor;
  }

  .weui-icon_msg {
    width: 64px;
    height: 64px;
  }

  .weui-icon-info {
    color: #10aeff;
    mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12%2022C6.477%2022%202%2017.523%202%2012S6.477%202%2012%202s10%204.477%2010%2010-4.477%2010-10%2010zm-.75-12v7h1.5v-7h-1.5zM12%209a1%201%200%20100-2%201%201%200%20000%202z%22%2F%3E%3C%2Fsvg%3E);
  }

  .weui-icon-success {
    color: #07c160;
    mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12%2022C6.477%2022%202%2017.523%202%2012S6.477%202%2012%202s10%204.477%2010%2010-4.477%2010-10%2010zm-1.177-7.86l-2.765-2.767L7%2012.431l3.119%203.121a1%201%200%20001.414%200l5.952-5.95-1.062-1.062-5.6%205.6z%22%2F%3E%3C%2Fsvg%3E);
  }

  .weui-icon-warn {
    color: #ffc300;
    mask-image: url(data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12%2022C6.477%2022%202%2017.523%202%2012S6.477%202%2012%202s10%204.477%2010%2010-4.477%2010-10%2010zm-.763-15.864l.11%207.596h1.305l.11-7.596h-1.525zm.759%2010.967c.512%200%20.902-.383.902-.882%200-.5-.39-.882-.902-.882a.878.878%200%2000-.896.882c0%20.499.396.882.896.882z%22%2F%3E%3C%2Fsvg%3E);
  }

  .msg-box {
    margin-top: 60px;

    p {
      font-size: 16px;
      font-weight: 600;
    }

    .header {
      margin-bottom: 40px;
    }
  }

  .button-box {
    margin-top: 40px;
    text-align: center;

    .button-wrapper {
      display: inline-block;
      width: 120px;
      height: 30px;

      .van-button--large {
        height: 40px;
      }
    }
  }

  .bind-scm-img {
    margin-top: 80px;

    img {
      width: 150px;
    }
  }
}
</style>
